import { useTranslation } from "react-i18next";
import styled from "styled-components";
import ManufacturerInfo from "../ManufacturerInfo";
import StatusProduct from "../StatusProduct";

const InforSection = () => {
    const { t, i18n } = useTranslation();
    return (
        <InfoSection>
            <h2 className="text-2xl font-bold mb-4">
                {i18n.language === "vi" ? "Ván ép chà dán - Tiêu chuẩn" : "Commercial Plywood"}
            </h2>
            <p className="mb-4">
                {i18n.language === "vi" ? (
                    <>
                        <strong>Ván ép chà dán</strong> của chúng tôi đảm bảo độ mịn và bằng phẳng
                    </>
                ) : (
                    <>
                        Our <strong>Commercial Plywood</strong> ensures smoothness and flatness
                    </>
                )}
            </p>
            <SpecsTable>
                <tbody>
                    <tr>
                        <SpecTdLabel>{t("measurement")}</SpecTdLabel>
                        <td>1220x2440mm, 910x1820mm,….</td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("popular-thickness")}</SpecTdLabel>
                        <td>
                            8.5mm - 4 {t("layer")} 1.7mm + 1 {t("layer")} 2mm
                            <br />
                            11.5mm - 7 {t("layer")} 1.7mm
                            <br />
                            14.5mm - 9 {t("layer")} 1.7mm
                            <br />
                            17.5mm - 11 {t("layer")} 1.7mm
                        </td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("tolerance")}</SpecTdLabel>
                        <td>±0.3mm</td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("veneer-grade")}</SpecTdLabel>
                        <td>{i18n.language === "vi" ? "Độn A/B/C" : "A/B/C"}</td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("application")}</SpecTdLabel>
                        <td>
                            {i18n.language === "vi"
                                ? "Pallet, robbin, nội thất, xây dựng..."
                                : "Pallet, robbin, furniture, construction..."}
                        </td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("glue")}</SpecTdLabel>
                        <td>MR urea formaldyhe</td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("formaldehyde-emission")}</SpecTdLabel>
                        <td>E0/E1/E2</td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("status")}</SpecTdLabel>
                        <td>
                            <StatusProduct />
                        </td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("manufacturer")}</SpecTdLabel>
                        <td>
                            <ManufacturerInfo />
                        </td>
                    </tr>
                </tbody>
            </SpecsTable>
        </InfoSection>
    );
};

export default InforSection;

const InfoSection = styled.div`
    flex: 1;
    max-width: 600px;
    width: 100%;
`;

const SpecsTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 16px;

    td {
        border: 1px solid #e1e1e1;
        color: #1c1c1c;
    }
`;

const SpecTdLabel = styled.td`
    font-weight: 600;
    width: 30%;
    min-width: 200px;
    @media (max-width: 768px) {
        width: 40%;
        min-width: 150px;
    }
    background-color: #f8f9fa;
`;
